module.exports = __webpack_public_path__ + "fonts/DidotLH-Italic.beb49a55.woff";